import { Loader } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { appStore } from '../stores/AppStore'

export const AppLoader = observer(() => {
  return <Loader show={appStore.isLoading} />
})
